var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilLine = function SvgPencilLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.855 9.918-1.272-1.273L6.2 17.028V18.3h1.273zm1.273-1.273L18.4 7.373 17.128 6.1l-1.273 1.273zm-8.91 11.456H4.4v-3.82l12.091-12.09a.9.9 0 0 1 1.273 0l2.546 2.545a.9.9 0 0 1 0 1.273L8.22 20.1h-.001Z"
  })));
};
export default SvgPencilLine;